<template>
  <div>
    <in-progress v-if="pageOnWorking" />
    <div
      v-if="!pageOnWorking"
      class="container"
    >
      <div class="cont-title">
        <div class="title">
          <h3 class="title">
            Logística y Transporte de la República Dominicana
          </h3>
          <p class="description-title">
            Las siguientes herramientas de libre acceso permiten una evaluación rápida
            de los costos de todos los renglones envueltos en distribución internacional de productos,
            así como la creación de data de seguimiento para la cadena de frío de productos perecederos.
          </p>
        </div>
        <div class="subtitle">
          <h4 class="boots">
            Herramientas
          </h4>
        </div>
      </div>

      <div class="my-items uk-flex uk-flex-row uk-flex-between">
        <div class="my-list">
          <div class="list products uk-flex">
            <div class="text-main">
              <span class="uk-flex">
                <span class="uk-badge">
                  <img
                    src="../../assets/img/SignDollar.png"
                    style="height: 15px;"
                  >
                </span>
                <span class="item-title">Simulación de Costos Logísticos de Importación y Exportación en República Dominicana</span>
              </span>
              <div class="products">
                <div class="item-product">
                  <p>
                    Esta herramienta permite simular los costos de todos los renglones. Envueltos en distribución internacional de productos.
                    El usuario selecciona los parámetros para el modelo y el sistema calcula los costos parametrizados para la cadena logística
                    de principio a fin.
                  </p>
                  <div class="btn">
                    <button
                      class="uk-button"
                      @click="pushPage('TransportChain')"
                    >
                      Comienza Ahora
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <img
              src="../../assets/img/main-img.png"
              class="img-main-responsive"
            >
          </div>

          <div class="list products uk-flex">
            <div class="text-main">
              <span class="uk-flex">
                <span class="uk-badge">
                  <img
                    src="../../assets/img/costs/Reefer.png"
                    width="25"
                    height="25"
                  >
                </span>
                <span class="item-title">Planeación y Seguimiento de la Cadena de Frío de Productos Perecederos</span>
              </span>
              <div class="products">
                <div class="item-product">
                  <p>
                    Esta herramienta permite la creación de una cadena de frío para productos perecederos,
                    así como un archivo para darle seguimiento a la cadena, que puede ser usado posteriormente
                    con fines de demostrar cómo se ha implementado.
                  </p>
                  <div class="uk-flex uk-flex-around uk-flex-wrap">
                    <div class="btn">
                      <button
                        class="uk-button"
                        @click="pushPage('DragAndDropTimeLine')"
                      >
                        Comienza Ahora Cadena de Frío
                      </button>
                    </div>
                    <div class="btn">
                      <button
                        class="uk-button"
                        @click="pushPage('SlideShow')"
                      >
                        Ver Informativo de Cadena de Frío
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <img
              src="../../assets/img/img-main-2.png"
              class="img-main-responsive"
            >
          </div>
        </div>
        <div class="img-div">
          <img
            src="../../assets/img/main-img.png"
            class="img-main"
          >

          <img
            src="../../assets/img/img-main-2.png"
            class="img-main"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InProgress from '../../views/InProgress.vue'

export default {
  components: { InProgress },
  data () {
    return {
      pageOnWorking: false
    }
  },
  methods: {
    pushPage (name) {
      this.$store.dispatch('resetCosts')
      this.$router.push({ name })
      this.$windowPlugin.scrollToTop()
    }
  }
}
</script>

<style scoped>
*{
  box-sizing: border-box;
}
.container{
    width: 100%;
    margin: 0px 0px;
    min-height: 552px;
}
.cont-title{
  margin: 20px 0px 0px;
}

.img-not-found{
  width: 40%;
  margin: auto;
  max-width: 600px;
}
.title h2{
  font-weight: 600;
  color:#343433;
}

.title h4{
  margin: 0px;
  color: #343433;

}

.container-page-working{
  height: 443px;
}

.main{
  margin: auto;
}

.main .title{
    text-align: left;
    margin: 5px auto;
    width: 100%;
}
.subtitle{
    margin: 30px auto 0px;
    width: 100%;
}
.subtitle strong{
  margin: 0px 5px;
}

.btn{
  display: flex;
  justify-content: center;
  flex-direction: row;
}
.item-product{
  margin: 0px ;
  font-size: 14px;
}

.h3-title{
  margin: 10px 0px;
}
.products{
  width: 96%;
  margin: 20px auto;
  text-align: justify;

}
.boots{
    text-align: left;
    margin: 0px;
    font-weight: 600;
    font-size: 16px;
}
.uk-badge{
    background-color: #fff;
    color: black;
}
.item-title{
    margin: 0px 10px;
    color: #333;
    font-size: 14px;
    font-weight: 600;
    width: 100%;
}

.description-title{
  color: #666;
  margin: 0px 10px;
  font-weight: normal;

}
.list{
    margin: 30px 10px 0px 0px;
}

.img-main{
  max-height: 200px;
  /* width: 50%; */
  margin-bottom: 30px;
  max-width: 250px;
}
.img-main-responsive{
  display: none;
}
.img-div{
  width: 300px;
}

.my-list{
  width: 100%;
}

.text-main{
   margin-right: 10px;
}

@media screen and (max-width: 1129px) {
  *{
    font-size: 11px;
  }
  .h3-title strong{
    font-size: 15px;
  }
  .title{
    font-size: 14px;
  }
  .boots{
    font-size: 14px;
  }

  .boots strong{
    font-size: 14px;
  }
  .item-title strong{
    font-size: 14px;
  }
}

@media screen and (max-width: 780px){
  .products{
    width: 100%;
    margin: 20px auto;
    text-align: justify;
    justify-content: center;
    flex-wrap: wrap ;
  }
  .list-products
  .list{
    border-bottom: 1px solid white;
  }
  .img-main{
    margin: 15px;
    width: 50%;
    max-width: 500px;
    max-height: 300px;
    order: 1;
  }
.img-div{
  display: none !important;
}
.img-main-responsive{
  display: block;
  margin: 15px;
  width: 50%;
  max-width: 500px;
  max-height: 300px;
  order: 1;
}
  .text-main{
    order: 2;
  }
  .title{
    text-align: center;
    margin: 0px auto 10px auto;
    width: 95%;
  }
  .boots{
    margin: 0px 10px;
  }
}

@media screen and (max-width: 500px){
  .my-list{
    width: 100%;
    text-align: center;
    margin: 0px 10px;
  }

  .products{
    width: 100%;
    margin: 10px auto;
    text-align: justify;

  }
  .img-main{
    margin: 15px;
    width: 70%;
  }

  .title{
    font-size: 12px;
  }
  .uk-button{
    font-size: 10px;
  }
  *{
    font-size: 10px;
  }
  .h3-title strong{
    font-size: 14px;
  }

  .boots{
    font-size: 12px;
  }
  .item-title {
    font-size: 12px;
  }
  .btn{
    margin: 10px 10px;
  }
}

</style>>
